export default {
  userGeoIP(state) {
    return state.userGeoIP;
  },
};
